export default __webpack_public_path__ + "static/media/bin.a5de3858.png";